import { createContext, useContext } from 'react';

/**
 * Carries the enclosing toolbar's `toolBarId` (GridToolBar/CoralToolbar, see
 * CustomToolbars.jsx) down to every button in ToolbarComponents.jsx, so a caller
 * building a leading child (EditCompoundsButton, AddCompoundButton) never has to repeat
 * the same id it already gave the toolbar itself. Every button reads it via
 * useToolBarId() rather than taking it as a prop - including the ones the toolbars
 * build internally (CsvExportButton, ExportButton, ChartButton), so there's one
 * mechanism, not two.
 *
 * Lives in its own file rather than either CustomToolbars.jsx (the provider) or
 * ToolbarComponents.jsx (the five consumers): CustomToolbars.jsx already imports the
 * button components from ToolbarComponents.jsx, so defining the context in either of
 * those two files would force the other to import it back - a circular import between
 * them. A third, shared file both import from one direction avoids that.
 */
const ToolBarIdContext = createContext(undefined);

export function useToolBarId() {
    return useContext(ToolBarIdContext);
}

export const ToolBarIdProvider = ToolBarIdContext.Provider;
